import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Carlos Eduardo",
    role: "Empresário",
    rating: 5,
    text: "Excelente serviço! A equipe da RL instalou o ar condicionado do meu escritório com muita competência. Entregaram no prazo e o acabamento ficou impecável. Recomendo a todos!",
    date: "2 meses atrás",
    avatar: "CE",
  },
  {
    name: "Maria Fernanda",
    role: "Administradora",
    rating: 5,
    text: "Contratei a RL para manutenção das câmaras frias do nosso restaurante. Serviço rápido, profissional e com preço justo. Já se tornaram nosso fornecedor fixo.",
    date: "1 mês atrás",
    avatar: "MF",
  },
  {
    name: "Dr. Roberto Santos",
    role: "Diretor Clínico",
    rating: 5,
    text: "A RL Refrigeração cuida de toda a climatização da nossa clínica. Sempre pontuais, atenciosos e com alto padrão técnico. Equipe muito profissional.",
    date: "3 semanas atrás",
    avatar: "RS",
  },
  {
    name: "Patrícia Lima",
    role: "Residencial",
    rating: 5,
    text: "Meu ar condicionado estava com problema há semanas. A RL resolveu no mesmo dia! Atendimento nota 10, técnico educado e explicou tudo direitinho.",
    date: "1 semana atrás",
    avatar: "PL",
  },
  {
    name: "João Marcos",
    role: "Gerente Industrial",
    rating: 5,
    text: "Fizemos a instalação completa do sistema chiller com a RL. Projeto excelente, equipe técnica qualificada e entrega dentro do prazo combinado. Nota máxima!",
    date: "2 semanas atrás",
    avatar: "JM",
  },
  {
    name: "Ana Clara",
    role: "Proprietária de Loja",
    rating: 4,
    text: "Ótimo custo-benefício! A manutenção preventiva que fazem no meu comércio é impecável. O ar funciona perfeitamente o ano todo. Super indico!",
    date: "3 meses atrás",
    avatar: "AC",
  },
];

function StarRating({ rating }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i <= rating ? "fill-[#FBBC04] text-[#FBBC04]" : "fill-gray-200 text-gray-200"}`}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section
      id="avaliacoes"
      data-testid="reviews-section"
      className="py-24 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#E0F2FE] text-[#0E86D4] text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 font-['Barlow_Condensed']">
            Avaliações
          </span>
          <h2
            data-testid="reviews-title"
            className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight"
          >
            O Que Nossos Clientes Dizem
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="flex items-center gap-1">
              <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" alt="Google" className="h-6" />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold text-[#0F172A] font-['Barlow_Condensed']">4.9</span>
              <StarRating rating={5} />
              <span className="text-sm text-[#64748B] font-['Manrope']">(127 avaliações)</span>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {REVIEWS.map((review, idx) => (
            <div
              key={review.name}
              data-testid={`review-card-${idx}`}
              className="review-card bg-white rounded-sm border border-gray-100 p-6"
            >
              {/* Header */}
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-[#0E86D4] flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-sm font-bold font-['Barlow_Condensed']">
                    {review.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-bold text-[#0F172A] font-['Barlow_Condensed']">
                    {review.name}
                  </h4>
                  <p className="text-xs text-[#64748B] font-['Manrope']">{review.role}</p>
                </div>
                {/* Google icon */}
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-2 mb-3">
                <StarRating rating={review.rating} />
                <span className="text-xs text-[#64748B] font-['Manrope']">{review.date}</span>
              </div>

              {/* Text */}
              <p className="text-sm text-[#334155] leading-relaxed font-['Manrope']">
                "{review.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
